import {
  CESSION_CATEGORY_LABELS,
  CESSION_STATUS_OPTIONS,
  type CessionStatus,
} from '~/constants/capitalMarkets';

const DEFAULT_LABEL = '-';

/**
 * Gets the label for a cession category
 */
export function getCategoryLabel(category?: string): string {
  if (!category) return DEFAULT_LABEL;
  return CESSION_CATEGORY_LABELS[category as keyof typeof CESSION_CATEGORY_LABELS] || category;
}

/**
 * Gets the label for a cession status
 */
export function getStatusLabel(status?: string): string {
  if (!status) return DEFAULT_LABEL;
  const statusOption = CESSION_STATUS_OPTIONS.find((option) => option.value === status);
  return statusOption?.name || status;
}

/**
 * Composable for cession label utilities
 */
export default function useCessionLabels() {
  return {
    getCategoryLabel,
    getStatusLabel,
  };
}
